<template>
  <v-container fluid class="mx-0 px-0 py-0 my-0">
    <v-row no-gutters class="py-0 my-0">
      <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
          <v-img
              height="auto"
              width="100vw"
              contain 
              :src="require('@/assets/news.jpg')">
          </v-img>
      </v-col>
    </v-row>
      <v-row class="image text-center mx-0 my-0">
        <v-col cols="12" class="text-center">
          <v-img
              class="white--text align-end"
              height="50vh"
              contain
              :src="getImage()"
          >
          </v-img>
        </v-col>
      </v-row>
      <v-row class="mx-0 my-0" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
        <v-col cols="12" class="text-center">
          <h2 class="title">
            {{article.title}}
          </h2>
        </v-col>
      </v-row>
      <v-row class="date mx-0 my-0" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
        <v-col cols="12">
          {{getDate()}}
        </v-col>
      </v-row>
      <v-row class="text pt-5 mx-0 my-0" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
          <span v-html="article.body"></span>
      </v-row>
  </v-container>
</template>


<script>
 import restApi from "@/rest-api";

  export default {
    data() {
        return {
            article:{},
            id: 0
        }
    },
    created() {
      this.fetchArticle(this.$route.query.articleId);
    },
    methods: {
      fetchArticle(id) {
        var search = `/article/${id}`;
        restApi
        .get(search)
        .then(response => {
              this.article = response.article
        })
        .catch((error) => {
            console.log(error);
        });
      },
      getImage() {
        if(this.article.image) {
          return `https://dev.paron-card.gr/uploads/images/${this.article.image.imageName}`
        } else {
          return require("@/assets/LOGOPARON 2023.png")
        }
      },
      getDate() {
        var date = new Date(this.article.createdAt)
        return date.getDate()+
          "/"+(date.getMonth()+1)+
          "/"+date.getFullYear()
      },
    }
  }
</script>

<style lang="scss" scoped>
    @media only screen and (min-width: 600px){
        .article{
            padding-top: 7%;
            width: 70%;
            height: auto;
            padding-bottom: 7%;
        }
    }

    @media only screen and (max-width: 600px){
        .article{
            padding-top: 20%;
            width: 90%;
            height: auto;
            padding-bottom: 20%;
        }
    }

    .title{
        text-align:center;
        font-weight:normal;
        padding-top: 3%;
        padding-bottom: 2%;
        font-size: 3vh!important;
    }
    .text{
        font-size: 2vh!important;
        padding:0% 10% 0% 10%; 
    }

</style>